/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DomainThreatThreatTypeEnum } from './DomainThreatThreatTypeEnum';
import {
    DomainThreatThreatTypeEnumFromJSON,
    DomainThreatThreatTypeEnumFromJSONTyped,
    DomainThreatThreatTypeEnumToJSON,
    DomainThreatThreatTypeEnumToJSONTyped,
} from './DomainThreatThreatTypeEnum';
import type { Status7f3Enum } from './Status7f3Enum';
import {
    Status7f3EnumFromJSON,
    Status7f3EnumFromJSONTyped,
    Status7f3EnumToJSON,
    Status7f3EnumToJSONTyped,
} from './Status7f3Enum';
import type { TakedownEvent } from './TakedownEvent';
import {
    TakedownEventFromJSON,
    TakedownEventFromJSONTyped,
    TakedownEventToJSON,
    TakedownEventToJSONTyped,
} from './TakedownEvent';
import type { Domain } from './Domain';
import {
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
    DomainToJSONTyped,
} from './Domain';

/**
 * 
 * @export
 * @interface PatchedDomainThreat
 */
export interface PatchedDomainThreat {
    /**
     * 
     * @type {number}
     * @memberof PatchedDomainThreat
     */
    readonly id?: number;
    /**
     * The potentially malicious domain name
     * @type {string}
     * @memberof PatchedDomainThreat
     */
    threatDomain?: string;
    /**
     * Type of domain-based threat
     * 
     * * `typosquatting` - Typosquatting
     * * `brand_infringement` - Brand Infringement
     * * `phishing` - Phishing Domains
     * @type {DomainThreatThreatTypeEnum}
     * @memberof PatchedDomainThreat
     */
    threatType?: DomainThreatThreatTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedDomainThreat
     */
    readonly threatTypeDisplay?: string;
    /**
     * Source where the threat was detected
     * @type {string}
     * @memberof PatchedDomainThreat
     */
    source?: string;
    /**
     * 
     * @type {Domain}
     * @memberof PatchedDomainThreat
     */
    readonly affectedDomain?: Domain;
    /**
     * 
     * @type {number}
     * @memberof PatchedDomainThreat
     */
    affectedDomainId?: number;
    /**
     * Current status of the threat investigation
     * 
     * * `new` - New
     * * `detected` - Detected
     * * `investigating` - Investigating
     * * `reported` - Reported
     * * `takendown` - Taken Down
     * @type {Status7f3Enum}
     * @memberof PatchedDomainThreat
     */
    status?: Status7f3Enum;
    /**
     * 
     * @type {string}
     * @memberof PatchedDomainThreat
     */
    readonly statusDisplay?: string;
    /**
     * Confidence level from 0-100%, null indicates Unknown
     * @type {number}
     * @memberof PatchedDomainThreat
     */
    confidenceLevel?: number | null;
    /**
     * Screenshot of the threatening domain
     * @type {string}
     * @memberof PatchedDomainThreat
     */
    screenshot?: string | null;
    /**
     * Detailed description of the threat
     * @type {string}
     * @memberof PatchedDomainThreat
     */
    description?: string;
    /**
     * 
     * @type {Array<TakedownEvent>}
     * @memberof PatchedDomainThreat
     */
    readonly takedownEvents?: Array<TakedownEvent>;
    /**
     * 
     * @type {Date}
     * @memberof PatchedDomainThreat
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedDomainThreat
     */
    readonly updatedAt?: Date;
}



/**
 * Check if a given object implements the PatchedDomainThreat interface.
 */
export function instanceOfPatchedDomainThreat(value: object): value is PatchedDomainThreat {
    return true;
}

export function PatchedDomainThreatFromJSON(json: any): PatchedDomainThreat {
    return PatchedDomainThreatFromJSONTyped(json, false);
}

export function PatchedDomainThreatFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedDomainThreat {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'threatDomain': json['threat_domain'] == null ? undefined : json['threat_domain'],
        'threatType': json['threat_type'] == null ? undefined : DomainThreatThreatTypeEnumFromJSON(json['threat_type']),
        'threatTypeDisplay': json['threat_type_display'] == null ? undefined : json['threat_type_display'],
        'source': json['source'] == null ? undefined : json['source'],
        'affectedDomain': json['affected_domain'] == null ? undefined : DomainFromJSON(json['affected_domain']),
        'affectedDomainId': json['affected_domain_id'] == null ? undefined : json['affected_domain_id'],
        'status': json['status'] == null ? undefined : Status7f3EnumFromJSON(json['status']),
        'statusDisplay': json['status_display'] == null ? undefined : json['status_display'],
        'confidenceLevel': json['confidence_level'] == null ? undefined : json['confidence_level'],
        'screenshot': json['screenshot'] == null ? undefined : json['screenshot'],
        'description': json['description'] == null ? undefined : json['description'],
        'takedownEvents': json['takedown_events'] == null ? undefined : ((json['takedown_events'] as Array<any>).map(TakedownEventFromJSON)),
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

  export function PatchedDomainThreatToJSON(json: any): PatchedDomainThreat {
      return PatchedDomainThreatToJSONTyped(json, false);
  }

  export function PatchedDomainThreatToJSONTyped(value?: Omit<PatchedDomainThreat, 'id'|'threat_type_display'|'affected_domain'|'status_display'|'takedown_events'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threat_domain': value['threatDomain'],
        'threat_type': DomainThreatThreatTypeEnumToJSON(value['threatType']),
        'source': value['source'],
        'affected_domain_id': value['affectedDomainId'],
        'status': Status7f3EnumToJSON(value['status']),
        'confidence_level': value['confidenceLevel'],
        'screenshot': value['screenshot'],
        'description': value['description'],
    };
}

